import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../../OptionsColor";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var TwinkleValues = /*#__PURE__*/function () {
  function TwinkleValues() {
    _classCallCheck(this, TwinkleValues);
    this.enable = false;
    this.frequency = 0.05;
    this.opacity = 1;
  }
  _createClass(TwinkleValues, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.color !== undefined) {
        this.color = OptionsColor.create(this.color, data.color);
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.frequency !== undefined) {
        this.frequency = data.frequency;
      }
      if (data.opacity !== undefined) {
        this.opacity = setRangeValue(data.opacity);
      }
    }
  }]);
  return TwinkleValues;
}();